import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import { LeadExecutionEngine } from '../../api/LeadExecutionEngine';
import { FiRefreshCw, FiTarget } from 'react-icons/fi';
import { toast } from 'react-hot-toast';
import LeadCard from '../../components/cards/LeadCard';
import AssumeLeadModal from '../../components/modals/AssumeLeadModal';

export default function LeadNovoPage() {
    const navigate = useNavigate();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [assumeLead, setAssumeLead] = useState(null);

    const loadData = async () => {
        setLoading(true);
        const res = await LeadExecutionEngine.listarPorStatus('NOVO');
        setLeads(res || []);
        setLoading(false);
    };

    useEffect(() => { loadData(); }, []);

    const handleAssumeLeadClick = (lead) => {
        setAssumeLead(lead);
    };

    return (
        <MainLayout>
            <div className="flex flex-col min-h-[90vh]">
                <div className="flex justify-between items-end mb-8">
                    <div>
                        <h1 className="text-4xl font-black uppercase tracking-tighter flex items-center gap-4 text-white">
                            <FiTarget className="text-emerald-500" />
                            Triagem de Leads
                        </h1>
                        <p className="text-[11px] font-bold text-[var(--text-secondary)] uppercase tracking-[0.2em] mt-1">
                            Novas Captações do Site e Campanhas
                        </p>
                    </div>

                    <button onClick={loadData} className="flex items-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 rounded-xl text-[10px] font-black uppercase transition-all text-white border border-white/10">
                        <FiRefreshCw className={loading ? "animate-spin" : ""} /> Atualizar Radar
                    </button>
                </div>

                {loading ? (
                    <div className="flex-1 flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500"></div>
                    </div>
                ) : leads.length === 0 ? (
                    <div className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-white/10 rounded-3xl opacity-50 p-12">
                        <FiTarget size={48} className="mb-4 text-emerald-500/50" />
                        <h2 className="text-2xl font-black uppercase text-white tracking-widest">Radar Limpo</h2>
                        <p className="text-xs uppercase font-bold tracking-widest mt-2">Nenhum Lead Novo no Momento</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {leads.map(lead => (
                            <div key={lead._id} className="relative group">
                                <LeadCard lead={lead} readOnly={true} />
                                <div className="absolute inset-0 bg-black/80 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-2xl flex items-center justify-center">
                                    <button 
                                        onClick={() => handleAssumeLeadClick(lead)}
                                        className="px-6 py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-black text-[11px] uppercase tracking-widest rounded-xl border-b-4 border-emerald-800 active:border-b-0 active:translate-y-1 transition-all"
                                    >
                                        Assumir Alvo
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            
            {assumeLead && (
                <AssumeLeadModal 
                    lead={assumeLead} 
                    onClose={() => setAssumeLead(null)} 
                    onRefresh={loadData}
                />
            )}
        </MainLayout>
    );
}
